export default __webpack_public_path__ + "static/z1-b6ba17f8be4435c99a21f5dc0fd40a2b.svg";